<template>
  <pt-user-roles class="pt-user-roles__page"></pt-user-roles>
</template>

<script>
import PtUserRoles from 'cps/customer-manage/pt-user-roles/withData'
export default {
  name: 'pt-user-roles__view',
  components: {
    'pt-user-roles': PtUserRoles
  }
}
</script>
